export const LANGUAGES = {
  en: { code: "en", label: "English", flag: "🇺🇸", shortLabel: "EN" },
  ja: { code: "ja", label: "日本語", flag: "🇯🇵", shortLabel: "日本語" },
};

export const DEFAULT_LANGUAGE = "en";
export const STORAGE_KEY = "portfolio-language";
